module.exports = "<p>\n  forecast-chart content\n</p>\n"